import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=24707ff2"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports